<template>
  <div
    v-if="visible"
    class="modal-overlay seats-modal-overlay"
    @click.self="close">
    <div role="dialog" class="seats-modal" :class="{ 'seats-modal--wide': wide }" @click.stop>
      <div class="seats-modal-header">
        <h3 class="seats-modal-title">{{ title }}</h3>
        <button type="button" class="seats-modal-close" @click="close">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>
        </button>
      </div>
      <div class="seats-modal-body">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SeatsModalShell',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    busy: {
      type: Boolean,
      default: false
    },
    // Modal com lista longa (compra de licenças): mais largo e mais alto, para caber
    // sem rolagem e com menos quebra de linha.
    wide: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    close () {
      if (this.busy) return
      this.$emit('close')
    }
  }
}
</script>

<style>
.seats-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}
.seats-modal {
  max-width: 30rem;
  width: 92%;
  background: #ffffff;
  border-radius: 0.75rem;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
}
.seats-modal--wide {
  max-width: 56rem;
  max-height: calc(100vh - 2rem);
  overflow-y: auto;
}
.seats-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.5rem 1.5rem 0.75rem 1.5rem;
}
.seats-modal-title {
  font-size: 1.125rem;
  font-weight: 700;
  margin: 0;
  color: #111827;
}
.seats-modal-close {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  color: #6b7280;
}
.seats-modal-body {
  padding: 0 1.5rem 1.5rem 1.5rem;
}
.seats-modal-text {
  font-size: 0.875rem;
  color: #4b5563;
  line-height: 1.45;
  margin: 0 0 1rem 0;
}
.seats-modal-success {
  font-size: 0.9375rem;
  color: #166534;
  line-height: 1.45;
  margin: 0 0 1rem 0;
}
.seats-modal-label {
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  margin: 0.75rem 0 0.375rem 0;
}
.seats-modal-select,
.seats-modal-input {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  color: #111827;
  background-color: #ffffff;
}
.seats-modal-warning {
  font-size: 0.8125rem;
  color: #b45309;
  margin: 0.375rem 0 0 0;
}
.seats-modal-error {
  font-size: 0.8125rem;
  color: #b91c1c;
  line-height: 1.45;
  margin: 1rem 0 0 0;
}
.seats-modal-summary {
  background-color: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 0.5rem;
  padding: 0.875rem 1rem;
  margin-top: 1.25rem;
}
.seats-modal-summary-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 1rem;
  font-size: 0.8125rem;
  color: #374151;
}
.seats-modal-summary-row + .seats-modal-summary-row {
  margin-top: 0.375rem;
}
.seats-modal-summary-row--total {
  font-size: 0.9375rem;
  font-weight: 700;
  color: #111827;
}
.seats-modal-link {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  padding: 0.625rem 1rem;
  background-color: #16a34a;
  color: #ffffff;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 600;
  text-decoration: none;
}
.seats-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
  padding-top: 1.25rem;
}
.seats-modal-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 2.5rem;
  padding: 0 1.5rem;
  border-radius: 0.5rem;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
}
.seats-modal-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.seats-modal-button--primary {
  background-color: #2563eb;
  color: #ffffff;
  border: none;
}
.seats-modal-button--secondary {
  background-color: #f9fafb;
  color: #374151;
  border: 1px solid #e5e7eb;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/seats/SeatsModalShell.vue